package org.vreo.devicehub.features.core.presentation

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.FormatStringsInDatetimeFormats
import kotlinx.datetime.format.byUnicodePattern
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant.Companion.fromEpochMilliseconds

/**
 * Timestamp in milliseconds to local date and time
 *
 * @param timeStampMs timestamp in milliseconds
 * @param timeZone time zone
 * @return local date and time
 */
@OptIn(ExperimentalTime::class)
fun timestampToDateAndTime(
    timeStampMs: Long,
    timeZone: TimeZone = TimeZone.currentSystemDefault()
): LocalDateTime {
    val instance = fromEpochMilliseconds(timeStampMs)
    return instance.toLocalDateTime(timeZone)
}

// Date format for message's data and time.
val dateFormat = LocalDate.Format {
    day()
    char('-')
    monthNumber()
    char('-')
    year()
}

/**
 * Get formated date from [LocalDateTime]
 *
 * @param dateTime date to format
 * @return formated date
 */
fun getFormatedDate(dateTime: LocalDateTime): String {
    return dateFormat.format(dateTime.date)
}

/**
 * Get formatted time from [LocalDateTime] in "hh:mm" format.
 *
 * @param time time to format
 * @return formatted time (e.g., "10:04")
 */
@OptIn(FormatStringsInDatetimeFormats::class)
fun getFormatedTime(time: LocalDateTime): String {
    val format = LocalDateTime.Format { byUnicodePattern("HH:mm") }
    return format.format(time)
}